export default "__VITE_ASSET__DBWoAuue__"